<template>
  <div :id="uuid" :style="{ width: width + 'px', height: height + 'px' }" />
</template>

<script setup>
import { getDataJson, pollingRefresh, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";

import { onMounted, watch, computed } from "vue";
import * as echarts from 'echarts'

const props = defineProps({
  width: Number,
  height: Number,
  option: Object,
  show: Boolean,
  components: Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow, (val) => {
  if (val && dataReload.value.includes(1)) {
    refreshCptData();
  }
})
watch(() => props.option.attribute.hideCompInTabw, (val) => {
  if (!val && dataReload.value.includes(1)) {
    refreshCptData();
  }
})

watch(() => props.option.attribute, (obj) => {
  if (obj.dataZoom && obj.dataZoom.show) {
    obj.grid.y2 = obj.grid.y2 == 30 ? 50 : obj.grid.y2;
  } else {
    obj.grid.y2 = obj.grid.y2 == 50 && obj.grid.y2 != 30 ? 30 : obj.grid.y2;
  }
  processData(props.option.cptDataForm, newData, jsFunFlag)
  loadChart(obj);
}, { deep: true })
watch(() => [props.width, props.height], () => {
  chart.resize()
})

let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(() => {
  if (document.getElementById(uuid)) {
    chart = echarts.init(document.getElementById(uuid))
    if (dataReload.value.includes(0)) {
      refreshCptData();
    }
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm, paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm, paras),
    props.components)
}
function loadData(cptDataForm, paras) {
  getDataJson(cptDataForm, paras, (res) => {
    // cptData = res;
    newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
    jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
    processData(cptDataForm, newData, jsFunFlag)
    loadChart(props.option.attribute);

  })
}
function processData(cptDataForm, res, jsFunFlag) {
  // 第一层判断 如果选择数据集
  if (cptDataForm.dataSource == '4') {
    // 第二层判断 ，如果没有配转换脚本
    if (jsFunFlag) { // 没有全部配置映射字段
      if (hasNonEmptyValues(props.option.attribute.cptTableData)) {
        const dataKey = props.option.attribute.cptTableData;
        console.log(dataKey, 'dataKey')
        let newarr = [];
        const fieldMap = dataKey.reduce((acc, curr) => {
          acc[curr.namekey] = curr.value;
          return acc;
        }, {});

        // 遍历原始数组并构建映射和新数组
        const groupMap = {};
        res.forEach(item => {
          const groupKey = item[fieldMap.group];
          if (!groupMap[groupKey]) {
            groupMap[groupKey] = {
              group: item[fieldMap.group],
              y: item[fieldMap.y],
              unit: item[fieldMap.unit],
              type: item[fieldMap.type],
              data: []
            };
          }

          // 构建data部分
          groupMap[groupKey].data.push({
            name: item[fieldMap.name],
            value: item[fieldMap.value]
          });
        });

        // 将映射转换为最终数组
        newarr = Object.values(groupMap);
        console.log(newarr, '新数组')
        cptData = newarr;
      }
    } else { // 如果配置了转换脚本
      cptData = res;
    }
  } else { // 不是数据集类型，是静态数据
    cptData = res;
  }
}
function loadChart(attribute) {
  const attr = JSON.parse(JSON.stringify(attribute));
  let xAisData = [];
  cptData[0] && cptData[0].data.forEach(item => {
    xAisData.push(item.name)
  })
  chartOption = {
    color: attr.color,
    title: attr.title,
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'cross' },
      ...attr.tooltip,
    },
    grid: attr.grid,
    legend: attr.legend,
    xAxis: attr.xAxis,
    yAxis:
      attr.yAxis,

    dataZoom: attr.dataZoom,
  }
  chartOption.xAxis.data = xAisData
  let series = []
  let seriesLabel = {};

  for (let i = 0; i < cptData.length; i++) {
    const item = cptData[i]
    seriesLabel = {
      ...attr.series.label,
      formatter: attr.series.label.unit ? '{c}' + (item.unit || '') : null
    }
    let data = []
    item.data.forEach(column => {
      data[xAisData.indexOf(column.name)] = column.value
    })
    series.push({
      name: item.group,
      type: item.type || 'bar',
      yAxisIndex: item.y === 'L' ? 0 : 1,
      data: data,
      smooth: attr.series.smooth,
      showBackground: attr.series.showBackground,
      label: seriesLabel,
      barWidth: attr.series.barWidth,
      tooltip: {
        valueFormatter: function (value) {
          return value + (item.unit || '');
        },

      },
    })
  }
  console.log(series, 'series');
  chartOption.series = series;
  if (!chart) {
    return
  }
  chart.setOption(chartOption, true);
  chart.on('click', (params) => {
    emit("clickHandler", props.option.interaction, 'default', params.name)
  })
}

defineExpose({ refreshCptData })
</script>

<style scoped></style>
